import { render, staticRenderFns } from "./nav-task.vue?vue&type=template&id=2a476fe3&"
import script from "./nav-task.vue?vue&type=script&lang=ts&"
export * from "./nav-task.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports